import React from "react";
import { Config } from "../config";

function NoOfferCard({ title, desc }) {
  return (
    <div className="mb-12 text-center">
      <img
        className="mx-auto mb-[-65px]"
        src={`${Config.app_url}/wp-content/uploads/2022/04/no-offer.png`}
        alt="noOfferIcon"
      />
      <h5 className="mb-2 text-xl font-medium">{title}</h5>
      <div className="text-opacity-50 text-dark">{desc}</div>
    </div>
  );
}

export default NoOfferCard;
